import { render } from "./helpList.vue?vue&type=template&id=67667ac1&scoped=true"
import script from "./helpList.vue?vue&type=script&lang=js"
export * from "./helpList.vue?vue&type=script&lang=js"

import "./helpList.vue?vue&type=style&index=0&id=67667ac1&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67667ac1"]])

export default __exports__